import type {
  Trips_GetTrip_GetTripQueryResponse_Success,
  Trips_Status_TripStatus,
} from "../../swagger-types/v1/index.js";
import { merge } from "lodash-es";
import { getFallbackImageUrl } from "../image-fixtures.js";

type TripDetailsMockStatus = Trips_Status_TripStatus | "PendingRefund";

export const createTripDetailsResponseMock = (
  status: TripDetailsMockStatus = "InProcess",
  tripKey?: string | null,
  overrides?: DeepPartial<Trips_GetTrip_GetTripQueryResponse_Success>,
): Trips_GetTrip_GetTripQueryResponse_Success => {
  const response: Trips_GetTrip_GetTripQueryResponse_Success = {
    trip: {
      isLegacy: false,
      tripId: 26859,
      tripKey: tripKey || "fb0976c1-172b-4517-ac47-247232d39a21",
      status: status as Trips_Status_TripStatus,
      deal: {
        hotelConfirmationNumber: "3452345",
        cancellationInsurance: null,
        pricing: {
          currencyCode: "USD",
          dealPrice: 284.0,
          roomsPrice: 233.26,
          fees: {
            total: { amount: 16.33, currency: "USD" },
            currency: "USD",
            breakdown: [
              {
                amount: 7.0,
                code: "ServiceCharge",
                description: "City tax",
              },
              {
                amount: 9.33,
                code: "ServiceCharge",
                description: "service fee Traveluro",
              },
            ],
          },
          hotelFees: {
            total: { amount: 80.32, currency: "USD" },
            currency: "USD",
            breakdown: [
              {
                amount: 80.32,
                code: "Unknown",
                description: "Resort fee",
              },
            ],
          },
          hotelFeeTaxes: {
            total: { amount: 0, currency: "USD" },
            currency: "USD",
            breakdown: [],
          },
          taxes: {
            total: { amount: 34.41, currency: "USD" },
            currency: "USD",
            breakdown: [
              {
                amount: 34.41,
                code: "Vat",
                description: "Tax",
              },
            ],
          },
        },
        roomId: 1,
        rooms: [],
        roomName: "Standard Room",
        boardCode: "RoomOnly",
        boardDescription: "Room Only",
        occupancies: [
          {
            adults: 2,
            children: [],
          },
        ],
        guest: {
          firstName: "Lemuel",
          lastName: "Kemmer",
          email: "Brenna27@hotmail.com",
          phone: "308.575.0106 x50129",
          countryCode: "VU",
        },
        specialRequests: "",
        checkIn: "2030-10-28",
        checkOut: "2030-10-30",
        totalNumberOfNights: 2,
        cancellationPolicy: {
          type: "Refundable",
          description:
            "Cancellations before Oct 5, 2024 12:00 PM (UTC) are fully refundable. Bookings canceled after Oct 5, 2024 12:00 PM (UTC) are non-refundable and cannot be amended. There is no refund for no-shows or early checkouts.",
          deadline: "2031-10-05T12:00:00",
        },

        hotel: {
          id: 125869,
          externalHotelId: "H125869",
          name: "The Renwick Hotel",
          starRating: 3,
          amenities: [],
          info: {
            reviewsSummary: null,
            reviewsRating: null,
            reviewsCount: 1813,
            reviewsRatingLevel: null,
            hotelDescription:
              "Featuring free WiFi, The Renwick Hotel New York City, Curio Collection by Hilton offers luxury residential-style accommodation in Midtown Manhattan, 400 metres from Bryant Park. Guests can enjoy the on-site restaurant and bar. Every art-inspired room at this historic hotel includes a flat-screen TV. Each room has a private bathroom with free toiletries and a hairdryer. There is a 24-hour front desk, fitness centre and business centre at The Renwick Hotel New York City, Curio Collection by Hilton. Bedford \u0026 Co. restaurant offers continental and American dishes. Grand Central Terminal is 270 metres from The Renwick Hotel New York City, Curio Collection by Hilton, while Empire State Building is 900 metres away. The nearest airport is La Guardia Airport, 9 km from the property.",
            checkinTime: "3:00 PM-midnight",
            checkoutTime: "12:00 PM",
            checkinInstructions: "",
          },
          reviews: [],
          images: [
            {
              largeUrl: getFallbackImageUrl(),
              mediumUrl: getFallbackImageUrl(),
              smallUrl: getFallbackImageUrl(),
              caption: "citizen",
              id: 1901,
              ordinal: 43,
              sources: [],
              main: false,
            },
          ],
          location: {
            countryCode: "US",
            countryName: "United States of America",
            stateCode: "NY",
            cityName: "Long Island City",
            address: "118 East 40th Street, New York, New York 10016",
            postalCode: "10016",
            latitude: 40.75028,
            longitude: -73.977516,
          },
        },
      },
      ancillaries: [],
      pricing: {
        totalProductsPrice: { amount: 0.0, currency: "USD" },
        totalPriceWithoutHotelFees: { amount: 284.0, currency: "USD" },
        totalPrice: { amount: 364.32, currency: "USD" },
        currency: "USD",
        paidPrice: { amount: 284.0, currency: "USD" },
        paidPriceWithHotelFees: { amount: 364.32, currency: "USD" },
        credits: [],
      },
      paymentPricing: {
        totalProductsPrice: { amount: 0.0, currency: "USD" },
        totalPriceWithoutHotelFees: { amount: 284.0, currency: "USD" },
        totalPrice: { amount: 364.32, currency: "USD" },
        currency: "USD",
        paidPrice: { amount: 284.0, currency: "USD" },
        paidPriceWithHotelFees: { amount: 364.32, currency: "USD" },
        credits: [],
      },
    },
  };

  return overrides ? merge(response, overrides) : response;
};
